import React from 'react';
import { Routes, Route, Navigate, generatePath } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useRoutes } from '@ui/hooks/useRoutes';
import AuthenticationPage from '@ui/pages/Authentication.page';
import MainPage from '@ui/pages/Main.page';
import HistoryPage from '@ui/pages/History.page';
import ReportsPage from '@ui/pages/Reports.page';
import SubusersPage from '@ui/pages/Subusers.page';
import StatisticsPage from '@ui/pages/Statistics.page';
import SupportPage from './pages/Support.page';
import SMSPage from '@ui/pages/SMS.page';
import GeozonesPage from './pages/Geozones.page';

const Router = () => {
    const { user, lang } = useRoutes();
    const userType = user.type;
    const isSubusersAllowed =
        userType === 'superuser' || userType === 'regular';

    const baseRoutes = (
        <>   
            <Route
                path="/auth"
                element={<AuthenticationPage lang={lang.lang} />}
            />         
        </>
    );
    const redirect = (
        <>        
            <Route path="*" element={<Navigate to="/" replace />} />          
        </>
    );
    const authRedirect = (
        <>        
            <Route path="*" element={<Navigate to="/" replace />} />
        </>
    );
       
     if (user.token) {
        return (
            <Routes>
                <Route path="/" element={<MainPage lang={lang.lang} />} />       
                <Route 
                path="/sms/*"
                element={<SMSPage/>}
            />         
                <Route
                    path="/history"
                    element={<HistoryPage lang={lang.lang} />}
                />
                <Route
                    path="/reports"
                    element={<ReportsPage lang={lang.lang} />}
                />
                {/* <Route
                    path="/statistics"
                    element={<StatisticsPage lang={lang.lang} />}
                /> */} // отключено до лучших времен
                {isSubusersAllowed && (
                    <Route
                        path="/subusers"
                        element={<SubusersPage lang={lang.lang} />}
                    />
                )}
                {userType === 'superuser' && (
                    <Route
                        path="/support"
                        element={<SupportPage lang={lang.lang} />}
                    />
                )}
                {userType === 'superuser' && <Route
                    path="/geozones"
                    element={<GeozonesPage lang={lang.lang} />}
                />}
                {redirect}
             </Routes>
         );
     } else {
         return (
             <Routes>
                 {baseRoutes}
                 {authRedirect}   
            <Route 
                path="/sms/*"
                element={<SMSPage/>}
            />
            <Route
                path="/auth"
                element={<AuthenticationPage lang={lang.lang} />}
            />         
            </Routes>
        );
     }
};
const Observable = observer(Router);

export default Observable;
